// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__OME7p","disabled":"FileBtn_disabled__1C3Zk","warn":"FileBtn_warn__1f3Sx","fade":"FileBtn_fade__3gect"};